import DownloadableContent from './DownloadableContent';

export default DownloadableContent;
